export const questions=[
    {
        title:"Qonunlar qanday tartibda o‘zgartiriladi?"
    },
    {
        title:"Qonunlar qanday tartibda o‘zgartiriladi?"
    },
    {
        title:"Qonunlar qanday tartibda o‘zgartiriladi?"
    },
    {
        title:"Qonunlar qanday tartibda o‘zgartiriladi?"
    },
    {
        title:"Qonunlar qanday tartibda o‘zgartiriladi?"
    },
    {
        title:"Qonunlar qanday tartibda o‘zgartiriladi?"
    },
    {
        title:"Qonunlar qanday tartibda o‘zgartiriladi?"
    },
    {
        title:"Qonunlar qanday tartibda o‘zgartiriladi?"
    },
    {
        title:"Qonunlar qanday tartibda o‘zgartiriladi?"
    },
    {
        title:"Qonunlar qanday tartibda o‘zgartiriladi?"
    },
]